import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import NextButtonInlineSvg from '../../../assets/svg-icons/NextButton.inline.svg';
import {BarButton} from '../BarButton/BarButton';
import styles from './NextButton.scss';

export function NextButton(props) {
  const {onClick, className: outerClassName} = props;
  const {t} = useTranslation();
  const className = classNames(styles.nextButton, outerClassName);

  return (
    <BarButton
      className={className}
      onClick={onClick}
      accName={t('mgw.aria.controlBar.nextButtonAccName')}
      SvgIcon={NextButtonInlineSvg}
      dataHook="next-button"
    />
  );
}

NextButton.propTypes = {
  t: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
